import { render, staticRenderFns } from "./LocalDataTable.vue?vue&type=template&id=6dd665d4&lang=pug"
import script from "./LocalDataTable.vue?vue&type=script&lang=js"
export * from "./LocalDataTable.vue?vue&type=script&lang=js"
import style0 from "./LocalDataTable.vue?vue&type=style&index=0&id=6dd665d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports